import { jsx as _jsx } from "react/jsx-runtime";
const SvgDota2Gold = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 8,
	height: 8,
	viewBox: "0 0 8 8",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M1.51312 1.995C2.16094 1.67125 3.02094 1.5 4 1.5C4.97906 1.5 5.83906 1.67125 6.48688 1.995C7.13469 2.31875 7.5 2.77437 7.5 3.25V4.75C7.5 5.22563 7.13063 5.68281 6.48688 6.005C5.84313 6.32719 4.97906 6.5 4 6.5C3.02094 6.5 2.16094 6.32875 1.51312 6.005C0.865313 5.68125 0.5 5.22563 0.5 4.75V3.25C0.5 2.77437 0.869375 2.31719 1.51312 1.995ZM4.25 4.995V5.995C4.84375 5.97563 5.34375 5.88813 5.75 5.76094V4.78281C5.26027 4.91329 4.7567 4.98473 4.25 4.99563V4.995ZM3.75 4.995C3.2433 4.98411 2.73973 4.91266 2.25 4.78219V5.76062C2.65625 5.88781 3.15625 5.97531 3.75 5.99469V4.995ZM7 4.75V4.17281C6.84267 4.30341 6.67043 4.41491 6.48688 4.505C6.41094 4.54281 6.33063 4.57844 6.25 4.61219V5.5625C6.74469 5.3175 7 5.00906 7 4.75ZM1.75 5.5625V4.61219C1.66844 4.57844 1.58906 4.54281 1.51312 4.505C1.32957 4.41491 1.15733 4.30341 1 4.17281V4.75C1 5.00906 1.25531 5.3175 1.75 5.5625Z",
		fill: "currentColor"
	})
});
export default SvgDota2Gold;
